/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/camelcase */

// libraries
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// pages
import Service from './Service';

// hooks
import useArticles from 'hooks/useArticles';
import useRealStories from 'hooks/useRealStories';
import useResize from 'hooks/useResize';
import useConvertedProviderCriteria from 'hooks/useConvertedProviderCriteria';

// content
import { SERVICE_ICONS, CONTENT_SERVICES, SERVICE_IMAGES } from './content';

// utils
import { getServiceIdFromLabel } from 'utils/getServiceIdFromLabel';

// selectors
import { selectServices } from 'modules/ProviderCriteria/selectors';

// components
import Head from 'components/Head';

const SCROLL_ARROW_STEP = 260;

const ServiceContainer = (): JSX.Element => {
  const { name } = useParams() as any;

  const { isDesktop } = useResize();

  const services = useSelector(selectServices);

  const { serviceOptions } = useConvertedProviderCriteria();

  const convertedName = name
    .split('-')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  const selectedService = services?.find((service: any) => service.value === convertedName);

  const currentService = (CONTENT_SERVICES.find((service: any) => service.id === convertedName.replace(/\s+/g, '')) ||
    CONTENT_SERVICES[0]) as any;

  const [selectedSubtitle, setSelectedSubtitle] = useState(currentService.subtitles[0]);

  const [serviceAssets, setServiceAssets] = useState({
    icon: '',
    image: '',
  });

  const history = useHistory();

  const { articles, handleRelatedArticleClick } = useArticles({ forServicePage: true, serviceId: selectedService?.id });

  const { stories, handleStoryClick } = useRealStories({
    forServicePage: true,
    serviceId: selectedService?.id,
  });

  const getAsset = useCallback(
    (serviceName: string, assetsList: any) => assetsList[serviceName.replace(/\s+/g, '')],
    [],
  );

  useEffect(() => {
    window.scrollTo(0, 0);

    setServiceAssets({ icon: getAsset(convertedName, SERVICE_ICONS), image: getAsset(convertedName, SERVICE_IMAGES) });

    // @ts-ignore
    document.getElementById('subtitleLink').click();
  }, [getAsset, convertedName]);

  const handleSelectSubtitle = useCallback(
    (subtitle: any) => () => {
      setSelectedSubtitle(subtitle);
    },
    [],
  );

  // when there will be all the icons on the main page for service cards i'll pass serviceId
  const handleRedirectToFindProvidersPage = useCallback(
    (label: string): void => {
      // @ts-ignore
      gtag('event', 'Find Your Specialist Click', {
        event_category: 'Service',
        event_label: 'Button Click',
      });
      // Navigate user to find provider page w/ search query
      const serviceId = getServiceIdFromLabel(label, serviceOptions);
      history.push(`/find-providers?serviceId=${serviceId}`);
      // Send user to top of page via this navigation
      window.scrollTo(0, 0);
    },
    [history, serviceOptions],
  );

  const handleRightArrowClick = useCallback(() => {
    const navigationBlock = document.getElementById('subtitles') as any;
    navigationBlock.scrollTo({
      behavior: 'smooth',
      left: navigationBlock.scrollLeft + SCROLL_ARROW_STEP,
    });
  }, []);

  const handlLeftArrowClick = useCallback(() => {
    const navigationBlock = document.getElementById('subtitles') as any;

    navigationBlock.scrollTo({
      behavior: 'smooth',
      left: navigationBlock.scrollLeft - SCROLL_ARROW_STEP,
    });
  }, []);

  return (
    <>
      <Head title={currentService.title} slug={currentService.slug} description={currentService.description} />
      <Service
        selectedSubtitle={selectedSubtitle}
        currentServiceName={convertedName}
        serviceAssets={serviceAssets}
        handleSelectSubtitle={handleSelectSubtitle}
        handleRedirectToFindProvidersPage={handleRedirectToFindProvidersPage}
        content={currentService}
        stories={stories}
        articles={articles}
        handleRightArrowClick={handleRightArrowClick}
        handlLeftArrowClick={handlLeftArrowClick}
        onStoryClick={handleStoryClick}
        onArticleClick={handleRelatedArticleClick}
        isDesktop={isDesktop}
      />
    </>
  );
};

export default ServiceContainer;
